/**
 * ADR 0007: the student area's root layout. It stamps `data-theme="student"`, which is what
 * makes the tokens in `theme.css` apply, and nothing else — the feed owns its own scrolling.
 */

import { Outlet } from "react-router";
import "./theme.css";

export function StudentLayout() {
  return (
    <div data-theme="student" className="no-select h-full bg-[var(--color-bg)]">
      <Outlet />
    </div>
  );
}
